$(window).on('load', function(){
    var dateTimeEl = $('.timer').attr('datetime');
    // Set your target date and time
    var now = new Date();
    var londonTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/London" }));

    const targetDate = parseCustomDate(dateTimeEl);

    function parseCustomDate(str) {
        const match = str.match(/^(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)\.\d+([+-]\d{2})(\d{2})$/);
        if (!match) return null;

        const [ , year, month, day, hour, min, sec, tzH, tzM ] = match.map(Number);
        return new Date(Date.UTC(year, month - 1, day, hour - tzH, min - tzM, sec));
    }

    if (isNaN(targetDate)) {
        console.error('Invalid Date parsed. Aborting.');
        return;
    }

    // Function to update the countdown
    function updateCountdown() {
        const currentDate = new Date();
        const timeDifference = targetDate - currentDate;
        if (timeDifference <= 0) {
            // The countdown has ended
            $('.timer span:not(.timer_expair_text)').hide();
          $('.notification-bar-sticky').addClass('timer-closed');
          $('.timer .timer_expair_text').show();

        } else {
            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            $("#days").text(days.toString().padStart(2, "0"));
            $("#hours").text(hours.toString().padStart(2, "0"));
            $("#minutes").text(minutes.toString().padStart(2, "0"));
            $("#seconds").text(seconds.toString().padStart(2, "0"));
        }
    }

    // Update the countdown every second
    setInterval(updateCountdown, 1000);

    // Initial call to set the initial values
    updateCountdown();
});